/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from "react";

export const useEditTable = ({
  list,
  onFormSubmit,
}: {
  list: any;
  onFormSubmit: (prop: any) => Promise<void>;
}) => {
  const [retailers, setRetailers] = useState<any>([]);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    const newList = structuredClone(list);
    const tempList = newList?.linked_retailers;
    if (tempList) {
      tempList.push({
        retailer_id: newList?.retailer_id,
        retailer_name: newList?.retailer_name,
        is_primary: true,
      });
      setRetailers(tempList);
    }
  }, []);

  const manageRetailer = ({ action, data }: { action: string; data: any }) => {
    if (action === "update") {
      setRetailers((prev: any) =>
        prev.map((item: any) => ({
          ...item,
          is_primary: item.retailer_id === data.id ? data.value : false,
        }))
      );
    }

    if (action === "delete") {
      setRetailers((prev: any) =>
        prev.filter((item: any) => item.retailer_id !== data.id)
      );
    }
  };

  const onSelect = (prop: any) => {
    const newRetailer: any = {
      retailer_id: prop.retailer_id,
      is_primary: retailers.length === 0 ? true : false,
      retailer_name: prop.retailer_name,
    };
    setRetailers((prev: any) => [...prev, newRetailer]);
  };

  const onSubmitHandler = async () => {
    const primary = retailers.find((item: any) => item.is_primary);
    const non_primary = retailers.filter((item: any) => !item.is_primary);
    const payload = {
      retailer_id: primary.retailer_id,
      retailer_name: primary.retailer_name,
      is_primary: true,
      linked_retailers: non_primary,
    };
    setLoader(true);
    await onFormSubmit(payload);
    setLoader(false);
  };

  return {
    retailers,
    manageRetailer,
    onSelect,
    loader,
    onSubmitHandler,
  };
};
